import { Injectable } from '@angular/core';
import { Message } from 'primeng/api';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToastMessageService {

  constructor() { }

  private showToastSubject = new Subject<Message>();

	showToast = this.showToastSubject.asObservable();

  show(message: Message) {
    this.showToastSubject.next(message);
  }
  
}
